import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const Subheading = styled(Typography)({
	fontSize: '18px',
	lineHeight: '24px',
	fontWeight: 600,
	marginBottom: '8px',
});

export default Subheading;
